module.exports = __webpack_public_path__ + "img/merchant.a639355b.svg";